/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {DB_Contact} from "@app/ir-q-app-common/types/db-contact";

export type ContactsMap = { [_id: string]: DB_Contact<any> };

export type ContactsContextType = {
    contacts: ContactsMap
    saveContacts: (contacts: DB_Contact<any>[]) => void
}

export const ContactsContext = React.createContext<ContactsContextType>({
    contacts: {},
    saveContacts: (contacts) => {}
});